import { Icon, IconProps } from '@elkaso-app/web-design';
import { HiDocumentText } from 'react-icons/hi';

export const PocCallTranscriptIcon = (props: IconProps) => {
  return <Icon as={HiDocumentText} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
